"use strict";

const elementList = document.getElementsByClassName("article__container");
const tabs = document.querySelector(".article__tab-list");
const activeClass = "article__tab--active";
const elementContainer = document.getElementsByClassName(
  "article__tab-container"
)[0];

if (tabs) {
  let deepLink = /(?!\W)(.*)(?:#)/.test(document.baseURI)
    ? document.baseURI
        .replace(/(?!\W)(.*)(?:#)/g, "")
        .replace(/(?=[\?\&])(.*)/g, "")
    : "president";

  const switchTab = (role) => {
    Object.keys(elementList[0].children).forEach((item) => {
      const element = elementList[0].children[item];
      const elementarray = element.dataset.role.split(",");
      element.classList.remove("__visuallyhidden");
      if (!elementarray.includes(role)) {
        element.classList.add("__visuallyhidden");
      }
    });
  };

  for (let item of tabs.children) {
    item.addEventListener("click", () => {
      document
        .getElementsByClassName("article__tab article__tab--active")[0]
        .classList.remove(activeClass);
      elementContainer.classList.toggle("__active");
      item.classList.add(activeClass);
      switchTab(item.dataset.role);
    });
    item.dataset.role === deepLink ? item.classList.add(activeClass) : null;
  }

  switchTab(deepLink);
}
